import './style.css';
import {useEffect, useState} from 'react';
import {useParams} from 'react-router-dom';
import AdviceDetail from '../../components/AdviceDetail';
import { FULL_ADVICES, getAdvicebyId } from '../../data/Advices.js';

function AdviceDetailContainer(){
    const {adviceId} = useParams();
    console.log("hola" + adviceId)
    const [advice, setAdvice] = useState(null);
    useEffect(() => {
        setAdvice(getAdvicebyId(adviceId));
        console.log(getAdvicebyId(adviceId));
    }, [adviceId]);
    
    return advice && <AdviceDetail item={advice}/>
}

export default AdviceDetailContainer;